import React, { useState, useEffect } from "react";

import { useTelegram } from "../../hooks/useTelegram"
import { motion } from "framer-motion";
import { getGame, updateFavorite } from "../../router/apiServiceFetch";
import { useAuth } from "../../contexts/AuthProvider";
import { CartIcon, HeartIcon } from "../GetIcons";
import Back from "../../assets/back.svg";
import Item from "../Item/Item";
import "./Games.scss";

const Games = ({ onClose, popupTitle, items, cartItems, handleRemoveFromCart, handleAddToCart }) => {

    const [selectedItem, setSelectedItem] = useState(null);
    const { tg, triggerHapticFeedback } = useTelegram();
    const { userBase } = useAuth();
    const [expandedGame, setExpandedGame] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const filePath = process.env.REACT_APP_FILE_PATH;


    const formatCurrency = (number) => {
        return new Intl.NumberFormat("ru-RU", {
            currency: "RUB",
            minimumFractionDigits: 2,
        }).format(number) + " руб";
    };
    const formatCurrencyDisc = (number) => {
        return new Intl.NumberFormat("ru-RU", {
            currency: "RUB",
        }).format(number);
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, 10);
        return () => clearTimeout(timeout);
    }, []);

    const handleClose = () => {
        if (expandedGame) {
            setExpandedGame(null);
        } else {
            setIsVisible(false);
            setTimeout(() => {
                onClose();
            }, 300);
        }
    };

    const handleGameClick = async (gameId) => {
        triggerHapticFeedback('impact', 'medium')
        if (expandedGame && expandedGame.gameId === gameId) {
            // Collapse if the same game is clicked
            setExpandedGame(null);
            setSelectedGroupId(null);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const gameDetails = await getGame(gameId, userBase.userId);
            setExpandedGame(gameDetails);

            if (gameDetails.gameGroups && gameDetails.gameGroups.length > 0) {
                setSelectedGroupId(gameDetails.gameGroups[0].groupId);
            } else {
                setSelectedGroupId(null);
            }
        } catch (error) {
            console.error("Error fetching game details:", error);
            setError("Failed to load game details.");
        } finally {
            setLoading(false);
        }
    };

    const getFilteredItems = () => {
        if (!expandedGame) return [];
        if (selectedGroupId === null) {
            return [
                ...(expandedGame.itemsWithoutGroup || []),
                ...expandedGame.gameGroups.flatMap((group) => group.items || []),
            ];
        }
        // Filter items by selected group ID
        const selectedGroup = expandedGame.gameGroups.find(
            (group) => group.groupId === selectedGroupId
        );
        return selectedGroup ? selectedGroup.items || [] : [];
    };

    const handleAdd = (item) => {
        handleAddToCart(item);
    };

    const handleRemove = (item) => {
        handleRemoveFromCart(item);
    };

    const handleFav = async (item) => {
        if (!expandedGame) return;
        const updatedGame = { ...expandedGame };
        // Toggling favorite for an item
        let itemUpdated = false;

        // If not found, check groups
        if (!itemUpdated && updatedGame.gameGroups && updatedGame.gameGroups.length) {
            updatedGame.gameGroups = updatedGame.gameGroups.map((group) => {
                if (!group.items) return group;
                const newItems = group.items.map((gameItem) => {
                    if (gameItem.itemId === item.itemId) {
                        itemUpdated = true;
                        return { ...gameItem, isFav: !gameItem.isFav };
                    }
                    return gameItem;
                });
                return { ...group, items: newItems };
            });
        }

        setExpandedGame(updatedGame);

        try {
            // Update the favorite status on the server
            await updateFavorite(userBase.userId, item.itemId);
        } catch (error) {
            console.error("Error updating favorite (item):", error);
        }

    };

    const filteredItems = getFilteredItems();

    const handleGameItemClick = (item) => {
        triggerHapticFeedback("impact", "medium");
        setSelectedItem(item); // Set the clicked item as the selected item
    };


    // Close the Item detail view
    const handleItemClose = () => {
        setSelectedItem(null);
    };
    return (
        <div className={`games-cont ${isVisible ? "visible" : ""}`}>
            {selectedItem ? (
                <Item gameItem={selectedItem} onClose={handleItemClose} />
            ) : (
                <div className="allItems">
                    <div className="nav">
                        <div className="back-nav">
                            <div className="back-btn" onClick={handleClose}>
                                <button>
                                    <img src={Back} alt="back" />
                                </button>
                            </div>
                            <h2>{expandedGame ? expandedGame.name : popupTitle}</h2>
                        </div>
                    </div>
                    <div className="allItems-content">
                        {error && <p className="error">{error}</p>}

                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: !expandedGame ? "auto" : 0, opacity: !expandedGame ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            {!expandedGame && (
                                <div className="gameDivs">
                                    {items.map((game, index) => (
                                        <div
                                            className="gameDiv"
                                            key={index}
                                            onClick={() => handleGameClick(game.gameId)}
                                        >
                                            <div className="gameDiv-inner">
                                                <img
                                                    src={`${filePath}/Games/${game.mainFileName}`}
                                                    alt={game.name}
                                                />
                                                <div className="gameDivText">
                                                    <h3>{game.name}</h3>
                                                    <p className="description">{game.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </motion.div>
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: expandedGame ? "auto" : 0, opacity: expandedGame ? 1 : 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            {expandedGame && (
                                <div className="gameDivs">
                                    <div className="gameDiv">
                                        <div className="gameDiv-inner">
                                            <img
                                                src={`${filePath}/Games/${expandedGame.mainFileName}`}
                                                alt={expandedGame.name}
                                            />
                                            <div
                                                className={`heartIcon ${expandedGame.isFav ? "isActiveFave" : ""}`}
                                                onClick={() => handleFav(expandedGame)}
                                            ></div>
                                            <div className="gameDivText">
                                                <h3>{expandedGame.name}</h3>
                                                <p className="description">{expandedGame.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="game-nav">
                                        <div className="game-nav-cont">
                                            {expandedGame.gameGroups.map((group) => (
                                                <button
                                                    key={group.groupId}
                                                    className={selectedGroupId === group.groupId ? "active" : ""}
                                                    onClick={() => {
                                                        triggerHapticFeedback('impact', 'medium')
                                                        setSelectedGroupId(group.groupId)
                                                    }}
                                                >
                                                    {group.name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="items">
                                        <div className="gridItems">
                                            {filteredItems.map((item, index) => {
                                                const cartItem = cartItems.find((cartItem) => cartItem.itemId === item.itemId);
                                                return (
                                                    <div className="gameSlide" key={index}>
                                                        <div className="gameSlide-inner">
                                                            <img
                                                                src={`${filePath}/Games/${item.fileName}`}
                                                                alt={item.name}
                                                                className="slideImage"
                                                                onClick={() => handleGameItemClick(item)}
                                                            />

                                                            <div className={`heartIcon ${item.isFav ? "isActiveFave" : ""}`}
                                                                onClick={() => handleFav(item)} // Fixed: Wrap in an arrow function
                                                            >
                                                                <HeartIcon fillColor={"#fff"} />
                                                            </div>
                                                            <div className="gameSliderText"
                                                                onClick={() => handleGameItemClick(item)}>
                                                                <h3>{item.name}</h3>
                                                                <div>

                                                                    <p>
                                                                        {formatCurrency(item.priceAfterDiscount)}
                                                                    </p>
                                                                    {item.discount > 0 && <span className="disc">-{item.discount}%</span>}
                                                                </div>
                                                            </div>
                                                            {cartItem ? (
                                                                <div className="gameSliderBtnDiv">
                                                                    <div className="gameSliderButtons">
                                                                        <button onClick={() => handleRemove(item)}>
                                                                            -
                                                                        </button>
                                                                    </div>
                                                                    <p className="quantity">{cartItem.quantity}</p>
                                                                    <div className="gameSliderButtons">
                                                                        <button onClick={() => handleAdd(item)}>
                                                                            +
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="gameSliderBtn">
                                                                    <button onClick={() => handleAdd(item)}>
                                                                        В Корзину
                                                                        <CartIcon fillColor="#FFAA00" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </motion.div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Games;
